module.exports = __webpack_public_path__ + "img/durham-logo.539fcefa.png";